import axios from 'axios';
import { apiBaseUrl } from '../../Component/connection';
import { showIpBanNotice } from '../../Component/axios_Interceptor/ipBanNotice';

// The public test workspace never uses platform administrator credentials.
export const integrationApi = axios.create({baseURL: apiBaseUrl(),timeout: 20000,headers:{'Content-Type':'application/json','X-Fanbird-Test':'1'}});

// Platform operators use their own HttpOnly session; seller tokens are never read here.
export const platformApi = axios.create({
  baseURL: `${apiBaseUrl()}platform-admin`,
  withCredentials: true,
  timeout: 20000,
  headers: {'Content-Type': 'application/json', 'X-Fanbird-Admin': '1'},
});

platformApi.interceptors.response.use(
  response => response,
  error => {
    showIpBanNotice(error);
    return Promise.reject(error);
  },
);

export function httpStatus(error: unknown): number | undefined {
  return (error as {response?: {status?: number}})?.response?.status;
}

export function errorMessage(error: unknown): string {
  const status = httpStatus(error);
  if (status === 401) return '로그인이 만료되었습니다. 다시 로그인해 주세요.';
  if (status === 403) return '팬버드 운영 관리자 권한이 필요합니다.';
  if (status === 409) return '다른 관리자가 먼저 변경했습니다. 최신 내용을 불러온 뒤 다시 확인해 주세요.';
  const message = (error as {response?: {data?: {message?: unknown}}})?.response?.data?.message;
  if (typeof message === 'string' && message) return message;
  if (Array.isArray(message) && message.every(item => typeof item === 'string')) return message.join(' ');
  if (!status) return '서버에 연결하지 못했습니다. 네트워크 상태를 확인하고 다시 시도해 주세요.';
  return '요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.';
}

// Test-run conflicts describe the runner state, not an administrator edit race.
export function integrationErrorMessage(error: unknown): string {
  if (httpStatus(error) === 409) {
    const message = (error as {response?: {data?: {message?: unknown}}})?.response?.data?.message;
    if (typeof message === 'string' && message) return message;
    if (Array.isArray(message) && message.length && message.every(item => typeof item === 'string')) return message.join(' ');
  }
  return errorMessage(error);
}
